export default [function StoreController() {}];
